import { render, staticRenderFns } from "./adminStaffDetail.vue?vue&type=template&id=f5120338&scoped=true"
import script from "./adminStaffDetail.vue?vue&type=script&lang=js"
export * from "./adminStaffDetail.vue?vue&type=script&lang=js"
import style0 from "./adminStaffDetail.vue?vue&type=style&index=0&id=f5120338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5120338",
  null
  
)

export default component.exports